import {OpportunityStudentContactPersonView} from './OpportunityStudentContactPersonView';
import {EmployerExperienceModel, HonourAndAwardsModel} from '../requests/StudentProfileEditModel';
import {OpportunityStudentViewOpportunityStudentStatus} from './Enums';

export class OpportunityStudentView implements IOpportunityStudentView {
  id?: string | undefined;
  opportunityId?: string | undefined;
  personId?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  createdByUserId?: string | undefined;
  updatedByUserId?: string | undefined;
  additionalInfo?: string | undefined;
  opportunityStudentStatus?: OpportunityStudentViewOpportunityStudentStatus | undefined;
  statusLastChangedByPersonId?: string | undefined;
  statusLastUpdated?: Date | undefined;
  studentIntroduction?: string | undefined;
  internshipDates?: string | undefined;
  sentByUserId?: string | undefined;
  dateFirstSent?: Date | undefined;
  dateLastSent?: Date | undefined;
  contactPeople?: OpportunityStudentContactPersonView[] | undefined;
  employerExperiences?: EmployerExperienceModel[] | undefined;
  employerHonourAwards?: HonourAndAwardsModel[] | undefined;
  publicProfile?: string | undefined;
  profileLastUpdated?: Date | undefined;
  profileUpdatedByUserId?: string | undefined;

  constructor(data?: IOpportunityStudentView) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.id = Data["id"];
      this.opportunityId = Data["opportunityId"];
      this.personId = Data["personId"];
      this.dateCreated = Data["dateCreated"] ? new Date(Data["dateCreated"].toString()) : <any>undefined;
      this.dateUpdated = Data["dateUpdated"] ? new Date(Data["dateUpdated"].toString()) : <any>undefined;
      this.createdByUserId = Data["createdByUserId"];
      this.updatedByUserId = Data["updatedByUserId"];
      this.additionalInfo = Data["additionalInfo"];
      this.opportunityStudentStatus = Data["opportunityStudentStatus"];
      this.statusLastChangedByPersonId = Data["statusLastChangedByPersonId"];
      this.statusLastUpdated = Data["statusLastUpdated"] ? new Date(Data["statusLastUpdated"].toString()) : <any>undefined;
      this.studentIntroduction = Data["studentIntroduction"];
      this.internshipDates = Data["internshipDates"];
      this.sentByUserId = Data["sentByUserId"];
      this.dateFirstSent = Data["dateFirstSent"] ? new Date(Data["dateFirstSent"].toString()) : <any>undefined;
      this.dateLastSent = Data["dateLastSent"] ? new Date(Data["dateLastSent"].toString()) : <any>undefined;
      if (Array.isArray(Data["contactPeople"])) {
        this.contactPeople = [] as any;
        for (let item of Data["contactPeople"])
          this.contactPeople!.push(OpportunityStudentContactPersonView.fromJS(item));
      }
      if (Array.isArray(Data["employerExperiences"])) {
        this.employerExperiences = [] as any;
        for (let item of Data["employerExperiences"])
          this.employerExperiences!.push(EmployerExperienceModel.fromJS(item));
      }
      if (Array.isArray(Data["employerHonourAwards"])) {
        this.employerHonourAwards = [] as any;
        for (let item of Data["employerHonourAwards"])
          this.employerHonourAwards!.push(HonourAndAwardsModel.fromJS(item));
      }
      this.publicProfile = Data["publicProfile"];
      this.profileLastUpdated = Data["profileLastUpdated"] ? new Date(Data["profileLastUpdated"].toString()) : <any>undefined;
      this.profileUpdatedByUserId = Data["profileUpdatedByUserId"];
    }
  }

  static fromJS(data: any): OpportunityStudentView {
    data = typeof data === 'object' ? data : {};
    let result = new OpportunityStudentView();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["opportunityId"] = this.opportunityId;
    data["personId"] = this.personId;
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    data["createdByUserId"] = this.createdByUserId;
    data["updatedByUserId"] = this.updatedByUserId;
    data["additionalInfo"] = this.additionalInfo;
    data["opportunityStudentStatus"] = this.opportunityStudentStatus;
    data["statusLastChangedByPersonId"] = this.statusLastChangedByPersonId;
    data["statusLastUpdated"] = this.statusLastUpdated ? this.statusLastUpdated.toISOString() : <any>undefined;
    data["studentIntroduction"] = this.studentIntroduction;
    data["internshipDates"] = this.internshipDates;
    data["sentByUserId"] = this.sentByUserId;
    data["dateFirstSent"] = this.dateFirstSent ? this.dateFirstSent.toISOString() : <any>undefined;
    data["dateLastSent"] = this.dateLastSent ? this.dateLastSent.toISOString() : <any>undefined;
    if (Array.isArray(this.contactPeople)) {
      data["contactPeople"] = [];
      for (let item of this.contactPeople)
        data["contactPeople"].push(item.toJSON());
    }
    if (Array.isArray(this.employerExperiences)) {
      data["employerExperiences"] = [];
      for (let item of this.employerExperiences)
        data["employerExperiences"].push(item.toJSON());
    }
    if (Array.isArray(this.employerHonourAwards)) {
      data["employerHonourAwards"] = [];
      for (let item of this.employerHonourAwards)
        data["employerHonourAwards"].push(item.toJSON());
    }
    data["publicProfile"] = this.publicProfile;
    data["profileLastUpdated"] = this.profileLastUpdated ? this.profileLastUpdated.toISOString() : <any>undefined;
    data["profileUpdatedByUserId"] = this.profileUpdatedByUserId;
    return data;
  }
}

export interface IOpportunityStudentView {
  id?: string | undefined;
  opportunityId?: string | undefined;
  personId?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  createdByUserId?: string | undefined;
  updatedByUserId?: string | undefined;
  additionalInfo?: string | undefined;
  opportunityStudentStatus?: OpportunityStudentViewOpportunityStudentStatus | undefined;
  statusLastChangedByPersonId?: string | undefined;
  statusLastUpdated?: Date | undefined;
  studentIntroduction?: string | undefined;
  internshipDates?: string | undefined;
  sentByUserId?: string | undefined;
  dateFirstSent?: Date | undefined;
  dateLastSent?: Date | undefined;
  contactPeople?: OpportunityStudentContactPersonView[] | undefined;
  employerExperiences?: EmployerExperienceModel[] | undefined;
  employerHonourAwards?: HonourAndAwardsModel[] | undefined;
  publicProfile?: string | undefined;
  profileLastUpdated?: Date | undefined;
  profileUpdatedByUserId?: string | undefined;
}
